/**
 * Round `value` up, optionally to a given number of decimal places.
 *
 * es-toolkit ships `round`/`floor` but not `ceil`, and the native `Math.ceil`
 * has no precision argument. This helper fills that gap while matching the
 * precision-aware, float-error-safe behaviour we relied on from lodash's
 * `ceil` (e.g. `ceil(4.006, 2) === 4.01`).
 */
export const ceil = (value: number, precision = 0): number => {
  if (!precision) return Math.ceil(value)

  // Shift the decimal point via the exponent to avoid binary float artefacts,
  // ceil on the integer-ish mantissa, then shift back.
  const [mantissa, exponent = '0'] = `${value}e`.split('e')
  const shifted = Math.ceil(Number(`${mantissa}e${Number(exponent) + precision}`))
  const [resMantissa, resExponent = '0'] = `${shifted}e`.split('e')
  return Number(`${resMantissa}e${Number(resExponent) - precision}`)
}
